import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { useDeleteSalesTeam } from '@user/store/salesTeam/hooks'
import { NoResultsCard } from '@sales-center/components'
import { ISalesTeam } from '@user/store/salesTeam/typings'
import { SalesTeamCard } from './SalesTeamCard/SalesTeamCard'

import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

const styles = {
  manage: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '16px',
    marginBottom: (theme: Theme) => theme.spacing(1.5),
    marginTop: (theme: Theme) => theme.spacing(3),
  },

  admin: {
    marginBottom: (theme: Theme) => theme.spacing(1.5),
    marginTop: (theme: Theme) => theme.spacing(3),
  },
}

interface Props {
  handleRefreshList: () => void
  handleShowEmployeesChange: () => void
  onEdit: (id: number) => void
  salesTeams: ISalesTeam[]
  showEmployees: boolean
}

export const SalesTeamList: React.FC<Props> = (props) => {
  const {
    handleRefreshList,
    handleShowEmployeesChange,
    onEdit,
    salesTeams,
    showEmployees,
  } = props

  const deleteSalesTeam = useDeleteSalesTeam()

  return (
    <Stack data-test-id="salesTeamList">
      <Box display="flex" flexDirection="column" marginBottom={2}>
        <Typography sx={{ ...styles.manage }}>
          Manage Your Sales Teams
        </Typography>
        <Box>
          <Switch
            size="small"
            checked={showEmployees}
            onChange={handleShowEmployeesChange}
          />
          View Employees
        </Box>
        <Typography sx={{ ...styles.admin }}>
          Admin users have top-level access to all Sales Teams and can own
          records on any team.
        </Typography>
      </Box>
      {salesTeams.length == 0 ? (
        <NoResultsCard label="No Sales Teams added yet" />
      ) : (
        salesTeams.map((s) => (
          <SalesTeamCard
            key={s.id}
            salesTeam={s}
            onEdit={onEdit}
            onDelete={deleteSalesTeam}
            handleRefreshList={handleRefreshList}
          />
        ))
      )}
    </Stack>
  )
}
